// discussionBoardReducer.js

const initialState = {
    posts: [],
    loading: false,
    error: null,
    alert: { open: false, message: "", severity: "success" },
};

export default function discussionBoardReducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_POSTS_REQUEST":
            return {
                ...state,
                loading: true,
                error: null,
            };
        case "FETCH_POSTS_SUCCESS":
            return {
                ...state,
                loading: false,
                posts: action.payload.posts,
            };
        case "FETCH_POSTS_FAILURE":
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                posts: [],
            };
        case "ADD_POST":
            return {
                ...state,
                posts: [...state.posts, action.payload.post],
            };
        case "ADD_COMMENT":
            return {
                ...state,
                posts: state.posts.map((post) =>
                    post.id === action.payload.postId
                        ? { ...post, comments: [...post.comments, action.payload.comment] }
                        : post
                ),
            };
        case "SET_ALERT":
            return {
                ...state,
                alert: action.payload.alert,
            };
        default:
            return state;
    }
}
